// extracted by LIB_CSS_EXTRACT_LOADER
import "./list-skeleton_module.css"
export default {"list":"list-SbRcHI","item":"item-_qvyzn","avatar":"avatar-qzVJkX","text":"text-STIwGx","primary":"primary-HPSdpG","secondary":"secondary-tamTw3"};